import {
    STATUS_SHIPMENT_TO_BE_SELF_COLLECTED,
    STATUS_SHIPMENT_DELIVERED,
} from '../constants/orderStatuses'

/**
 * Returns true when ShowOrderContainer should inject an UPCOMING
 * `to_be_self_collected` placeholder step into orderHistory so the
 * PickupActionChip has a step to attach to in the pre-arrival state.
 *
 * The upcoming-event branches in the orderHistory useMemo
 * (addUpcomingInTransitEvent / isCurrentLastDeliveryAttempt /
 * upcomingDeliveredItem) all skip when isPickup is true, leaving no
 * step matching STATUS_SHIPMENT_TO_BE_SELF_COLLECTED for CnC orders.
 */
export function shouldInjectCncPickupPlaceholder({
    isPickup,
    isClickAndCollect,
    hasMetadata,
    willNotDeliverOrder,
    isEntirelyDropshipping,
    orderHistorySoFar,
}) {
    if (!isPickup) return false
    if (!isClickAndCollect) return false
    if (!hasMetadata) return false
    if (willNotDeliverOrder) return false
    if (isEntirelyDropshipping) return false
    if (orderHistorySoFar.some(s => s.name === STATUS_SHIPMENT_TO_BE_SELF_COLLECTED)) return false
    if (orderHistorySoFar.some(s => s.name === STATUS_SHIPMENT_DELIVERED)) return false
    return true
}
